import { UserQuelleAllgemein } from './user-quelle-allgemein.model';

export class UserQuelleFlaeche extends UserQuelleAllgemein {
  idUserQuelleFlaeche: number;
  idFlaechenquellart: number;
  idMmFlaechenZuord: number;
  wirkungsgrad: number;
  laengeHoehe: number;
  breite: number;
  durchmesser: number;
  
}
